import React from 'react'
import { formatLiters } from './format'

interface IFuel {
  id: string
  name: string
  quantity: number
}

/** Only what is actually there — a fuel at zero is not a leftover. */
const left = (fuels: IFuel[]) => fuels.filter((fuel) => fuel.quantity > 0)

interface IFLeftovers {
  fuels: IFuel[]
  /** Whose litres these are — «Залишок» of the account, «Залишок на рахунку» of the wallet. */
  label: string
  icon: React.ReactNode
  /** The plain hint shown instead when there is nothing left. */
  empty: string
}

/**
 * The litres of each fuel as a row of chips under a picker, the figure in the
 * primary colour so the leftovers stand out from the hint text around them.
 * The cabinet modal puts it under the account, the page for app users under
 * the wallet.
 */
const Leftovers: React.FC<IFLeftovers> = ({ fuels, label, icon, empty }) => {
  const items = left(fuels)

  if (!items.length) {
    return (
      <span className="refuel-hint">
        {icon} {empty}
      </span>
    )
  }

  return (
    <div className="refuel-leftovers">
      <span className="refuel-leftovers__label">
        {icon} {label}
      </span>
      {items.map((fuel) => (
        <span key={fuel.id || fuel.name} className="refuel-leftovers__item">
          {fuel.name} <b>{formatLiters(fuel.quantity)} л</b>
        </span>
      ))}
    </div>
  )
}

/** «А-95 90 л · ДП 30 л» on one line for a Select option, the litres emphasised. */
export const FuelsInline: React.FC<{ fuels: IFuel[] }> = ({ fuels }) => {
  const items = left(fuels)
  if (!items.length) return <>немає залишків</>
  return (
    <>
      {items.map((fuel, index) => (
        <React.Fragment key={fuel.id || fuel.name}>
          {index > 0 && ' · '}
          {fuel.name} <b>{formatLiters(fuel.quantity)} л</b>
        </React.Fragment>
      ))}
    </>
  )
}

export default Leftovers
